import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, Switch, FormControlLabel, Avatar, Tooltip } from '@material-ui/core';
import { BackArrow } from '../../../config/svg/GlobalSvg';
import { checkUnSavePopUpVisible, getUserDetails, getUserName } from '../../../config/utils';
import { AlertInfoIcon, NextIcon } from '../../../config/svg/CommonSvg';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Enums } from '../../../config/enums';
import { saveMultipleAssessmentForm } from '../../../action/UserPerformance';
import AlertDialog from '../../Common/Dialog';
import { AssessmentPopup } from '../../Common/AssessmentPopup';
import { OKRButton } from '../../Common/OKRButton';
import { ShortAnswerRating } from '../../Common/PerformanceComponent/ShortAnswerRating';
import { SliderRating } from '../../Common/PerformanceComponent/SliderRating';
import { MultiChoiceRating } from '../../Common/PerformanceComponent/MultiChoiceRating';
import { StarRating } from '../../Common/PerformanceComponent/StarRating';
import { showLoader } from '../../../action/common';
import { TeamAssessmentHeader } from '../TeamAssessmentHeader';
import { getMultipleAssessment } from '../../../action/perform';

export const MultipleThreeSixtyAssessmentDetailsForm = (props: any) => {
	const {
		performanceCycle,
		loader,
		setLoader,
		backClicked,
		employeeId,
		selectedUserAssessment,
		handleBack,
		userDetail,
		multipleAssessmentResponse,
		performanceCycleId,
		getTeamAssessList,
		performanceRoleId,
		performanceRatings,
		handleOneOnOneClick,
		handleSnapshot,
		getSelfAssessmentDetails,
		isViewMode = false,
		callingType,
		isFormEdited,
		setIsFormEdited,
		assessmentType = '',
		fromTeamAssessment,
		isFinalRating = false,
		getEmployeeAssessmentDetails = () => {},
		refComp,
	} = props;
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();

	const [assessmentFormDetails, setAssessmentFormDetails] = useState<any>(null);
	const [assessmentPopup, setAssessmentPopup] = useState<any>({ open: false, details: null });
	const [modalProps, setModalProps] = useState<any>({ open: false, event: {}, message: '' });
	const [isInitialRender, setIsInitialRender] = useState<boolean>(true);

	useEffect(() => {
		if (multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections) {
			// setLoader(false);
			setAssessmentFormDetails(
				addQuestionNumber(multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections)
			);
			setIsInitialRender(true);
		}
		if (multipleAssessmentResponse) {
			dispatch(showLoader(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [multipleAssessmentResponse]);

	const addQuestionNumber = (details: any, isManager = false) => {
		let quesNumber = 0;
		const updatedDetails =
			details && details?.length
				? [...details].map((section: any) => {
						if (
							section?.multiplePerformanceRoleLinkedFormDetails &&
							section?.multiplePerformanceRoleLinkedFormDetails?.length
						) {
							section.multiplePerformanceRoleLinkedFormDetails = section?.multiplePerformanceRoleLinkedFormDetails.map(
								(question: any) => {
									quesNumber = quesNumber + 1;
									question.questionNumber = quesNumber;

									return question;
								}
							);
						} else if (
							isManager &&
							section?.performanceRoleLinkedFormDetails &&
							section?.performanceRoleLinkedFormDetails?.length
						) {
							section.multiplePerformanceRoleLinkedFormDetails = section?.performanceRoleLinkedFormDetails.map(
								(question: any) => {
									quesNumber = quesNumber + 1;
									question.questionNumber = quesNumber;
									question.multipleRatingAssessmentDetail = [question.performanceRoleLinkedFormDetails];
									return question;
								}
							);
						}
						return section;
				  })
				: details;
		return updatedDetails;
	};

	const getLabelText = (value: number, labels: any) => {
		return `${labels[value - 1]?.name || ''}`;
	};
	const getDynamicMarks = (marksLength: any, ratingValue: any) => {
		const marks = marksLength?.map((item: any, index: number) => ({
			...item,
			value: index + 1,
			// label: item?.name || index.toString(),
			label:
				index === 0 || index === marksLength?.length - 1 ? (
					<span
						className={`${ratingValue ? '' : 'show_slider_label'} ${
							!ratingValue ? '' : ratingValue - 1 === index ? 'show-selected-label-value' : 'hide_slider_label'
						}`}
					>
						{item?.name || index.toString()}
					</span>
				) : (
					<span
						className={`${ratingValue ? '' : 'show_slider_label'} ${
							!ratingValue ? '' : ratingValue - 1 === index ? 'show-selected-label-value' : 'hide_slider_label'
						}`}
					>
						{item?.name || index.toString()}
					</span>
				),
		}));
		marks.unshift({
			value: 0,
			label: '',
		});
		return marks;
	};
	const getSelectedScaleValueIndex = (selectedScaleId: any, scaleItems: any) => {
		const marks = scaleItems?.findIndex(
			(item: any) => item?.performanceRoleLinkedFormScaleDetailId === selectedScaleId
		);
		return marks > -1 ? marks + 1 : 0;
	};
	const getSelectedStartValueIndex = (selectedStartId: any, starItem: any) => {
		const marks = starItem?.findIndex((item: any) => item?.performanceRoleLinkedFormScaleDetailId === selectedStartId);
		return marks > -1 ? marks + 1 : 0;
	};
	const getSelectedMultiChoiceValue = (selectedScaleId: any, performanceRoleLinkedFormScaleDetailId: any) => {
		return Boolean(selectedScaleId === performanceRoleLinkedFormScaleDetailId) || false;
	};
	const getQuestionNumber = (section: any, question: any, sectionIndex: number, questionIndex: number) => {
		return `${question?.questionNumber || 0}. `;
	};
	const handleClearAssessmentForm = (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			if (isFormEdited) {
				setModalProps({ open: true, event: null, type: 'ClearForm', message: t('clearAssessmentForm') });
			} else {
				if (multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections) {
					setAssessmentFormDetails(
						addQuestionNumber(multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections)
					);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleSaveAsDraftAssessmentForm = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			setLoader(true);
			if (assessmentFormDetails && assessmentFormDetails?.length) {
				handleSaveAssessmentAPICall(Enums.ONE, Enums.ONE);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};
	const handleSubmitAssessmentForm = async (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			setLoader(true);
			if (checkAssessmentFormValidation()) {
				if (assessmentFormDetails && assessmentFormDetails?.length) {
					handleSaveAssessmentAPICall(Enums.TWO, Enums.ONE);
				} else {
					setLoader(false);
				}
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};

	const handleSaveAssessmentAPICall = async (status: any, performanceType = Enums.ONE) => {
		try {
			const requestPayload = {
				performanceCycleId: performanceCycle?.performanceCycleId || Enums.ZERO,
				ratingAssessmentId: multipleAssessmentResponse?.ratingAssessmentId || Enums.ZERO,
				// employeeId: userDetails?.employeeId || Enums.ZERO,
				// reportingTo: userDetails?.reportingTo || Enums.ZERO,
				ratingAssessmentType: multipleAssessmentResponse?.ratingAssessmentType || Enums.ZERO,
				status: status || Enums.ZERO,
				multiplePerformanceRoleLinkedFormSections: [...assessmentFormDetails],
			};
			const response: any = await dispatch(saveMultipleAssessmentForm(requestPayload));
			if (response && response?.data && response.data?.status === Enums.STATUS_SUCCESS) {
				const { messageList } = response?.data || {};
				const keys = messageList ? Object.keys(messageList) : [];
				const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
				enqueueSnackbar(
					messages ? messages : status === Enums.TWO ? 'Successfully saved in drafts.' : `Successfully saved.`,
					{
						variant: 'success',
						autoHideDuration: 3000,
					}
				);

				// if (performanceCycle?.performanceCycleId) {
				// 	setLoader(true);
				// 	getSelfAssessmentDetails(
				// 		userDetails?.employeeId || Enums.ZERO,
				// 		performanceCycle?.performanceCycleId || Enums.ZERO,
				// 		performanceType || Enums.ONE
				// 	);
				// }
				setIsFormEdited(false);
				backClicked(true);
				setLoader(false);
			} else {
				const { messageList } = response?.data || {};
				const keys = messageList ? Object.keys(messageList) : [];
				const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
				enqueueSnackbar(messages || `Error occurred while updating assessment form.`, {
					variant: 'error',
					autoHideDuration: 3000,
				});
				setLoader(false);
			}
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};
	const checkAssessmentFormValidation = () => {
		let isFormValidated = true;
		let firstErrorQuestion = 0;
		let firstErrorQuestionComment = 0;
		if (assessmentFormDetails && assessmentFormDetails?.length) {
			let updatedAssessmentFormDetails = [...assessmentFormDetails].map((item: any) => {
				const data = { ...item };
				return data;
			});
			updatedAssessmentFormDetails = [...updatedAssessmentFormDetails].map((section: any) => {
				const sectionData = { ...section };
				if (
					sectionData?.multiplePerformanceRoleLinkedFormDetails &&
					sectionData?.multiplePerformanceRoleLinkedFormDetails?.length
				) {
					sectionData.multiplePerformanceRoleLinkedFormDetails =
						sectionData.multiplePerformanceRoleLinkedFormDetails.map((ques: any) => {
							const quesData = { ...ques };
							quesData.multipleRatingAssessmentDetail =
								quesData?.multipleRatingAssessmentDetail && quesData?.multipleRatingAssessmentDetail?.length
									? quesData?.multipleRatingAssessmentDetail.map((employee: any, employeeIndex: number) => {
											const empData = { ...employee };
											if (
												quesData?.isQuestionsMandatory &&
												(!empData?.ratingValue ||
													(empData?.ratingValue &&
														typeof empData.ratingValue === 'string' &&
														empData.ratingValue.trim() === ''))
											) {
												empData.isQuestionError = true;
												empData.isQuestionErrorMsg = 'This question is mandatory to answer';
												firstErrorQuestion = ++firstErrorQuestion;
												isFormValidated = false;
												if (firstErrorQuestion === 1 && firstErrorQuestionComment === 0) {
													scrollTo(
														`section_question_index_value_${sectionData?.performanceRoleLinkedFormSectionId}_${quesData?.performanceRoleLinkedFormDetailsId}_${quesData?.performanceRoleLinkedFormScaleId}_${empData?.employeeId}`
													);
												}
											}
											if (quesData?.isCommentBoxAvailable && quesData?.isCommentBoxMandatory) {
												if (
													!empData?.questionCommentBox ||
													(empData?.questionCommentBox && empData.questionCommentBox.trim() === '')
												) {
													empData.isCommentExpand = true;
													empData.isQuestionCommentError = true;
													empData.isQuestionCommentErrorMsg = 'This question comment is mandatory to answer';
													firstErrorQuestionComment = ++firstErrorQuestionComment;
													isFormValidated = false;
													if (firstErrorQuestionComment === 1 && firstErrorQuestion === 0) {
														scrollTo(
															`section_question_index_value_${sectionData?.performanceRoleLinkedFormSectionId}_${quesData?.performanceRoleLinkedFormDetailsId}_${quesData?.performanceRoleLinkedFormScaleId}_${empData?.employeeId}`
														);
													}
												}
											}

											return empData;
									  })
									: [];

							return quesData;
						});
				}

				return sectionData;
			});

			setAssessmentFormDetails([...updatedAssessmentFormDetails]);
		}
		return isFormValidated;
	};
	const scrollTo = (elementId: string) => {
		setTimeout(function () {
			const element = document.getElementById(elementId);
			let topPos = element?.offsetTop;
			topPos = topPos ? topPos - 180 : 0;
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
				window.scroll({ top: topPos, behavior: 'smooth' });
			}
		}, 100);
	};

	// =========================================================================================
	const handleChangeStarQuestionValue = (
		event: any,
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'ratingValue',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeStarQuestionHoverValue = (
		event: any,
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			event.preventDefault();
			event.stopPropagation();
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'starRatingHoverValue',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeScaleQuestionValue = (
		event: any,
		valueIndex: any,
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		isCommitted: boolean,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			event.preventDefault();
			event.stopPropagation();
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'ratingValue',
				value,
				isCommitted
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeMultiChoiceQuestionValue = (
		event: any,
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			event.preventDefault();
			event.stopPropagation();
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'ratingValue',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeQuestionComment = (
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'questionCommentBox',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeShortQuestionValue = (
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'ratingValue',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};
	const handleCommentsToggle = (
		e: any,
		value: any,
		question: any,
		questionIndex: number,
		section: any,
		sectionIndex: number,
		employeeDetails: any,
		employeeIndex: number
	) => {
		try {
			e.preventDefault();
			e.stopPropagation();
			updateAssessmentFormDetails(
				{ employeeDetails, employeeIndex },
				sectionIndex,
				questionIndex,
				'isCommentExpand',
				value
			);
		} catch (error) {
			console.error(error);
		}
	};

	const handlePreviousQuestionClick = (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
		} catch (error) {
			console.error(error);
		}
	};
	const handleNextQuestionClick = (e: any) => {
		try {
			e.preventDefault();
			e.stopPropagation();
		} catch (error) {
			console.error(error);
		}
	};

	const updateAssessmentFormDetails = (
		employeeInfo: any,
		sectionIndex: number,
		questionIndex: number,
		keyName: string,
		value: any,
		scaleCommittedFlag = false
	) => {
		try {
			if (assessmentFormDetails && assessmentFormDetails?.length) {
				const { employeeIndex = 0 } = employeeInfo; // { employeeDetails, employeeIndex } = employeeInfo
				let updatedAssessmentFormDetails = [...assessmentFormDetails].map((item: any) => {
					const data = { ...item };
					return data;
				});
				updatedAssessmentFormDetails = [...updatedAssessmentFormDetails].map((section: any, indexVal: number) => {
					const sectionData = { ...section };
					if (indexVal === sectionIndex) {
						sectionData.multiplePerformanceRoleLinkedFormDetails =
							sectionData.multiplePerformanceRoleLinkedFormDetails.map((ques: any, quesIndex: number) => {
								const quesData = { ...ques };
								quesData.multipleRatingAssessmentDetail = quesData?.multipleRatingAssessmentDetail.map(
									(emp: any, empIndex: number) => {
										const empDetail = { ...emp };
										if (empIndex === employeeIndex) {
											if (quesIndex === questionIndex && keyName) {
												if (keyName === 'isCommentExpand') {
													empDetail[keyName] = !empDetail?.isCommentExpand;
												} else {
													if (keyName !== 'starRatingHoverValue' || scaleCommittedFlag) {
														empDetail.isQuestionError = false;
														empDetail.isQuestionErrorMsg = '';
													}
													if (keyName === 'questionCommentBox') {
														empDetail.isQuestionCommentError = false;
														empDetail.isQuestionCommentErrorMsg = '';
													}
													if (keyName === 'ratingValue') {
														empDetail[keyName] = value ? String(value) : '';
														if (quesData?.isCommentBoxMandatory && !empDetail?.questionCommentBox) {
															empDetail.isCommentExpand = true;
														}
													} else {
														empDetail[keyName] = value;
													}
												}
											}
										}

										return empDetail;
									}
								);

								return quesData;
							});
					}
					return sectionData;
				});
				// updatedAssessmentFormDetails[sectionIndex].multiplePerformanceRoleLinkedFormDetails =
				// 	updatedAssessmentFormDetails[sectionIndex].multiplePerformanceRoleLinkedFormDetails?.length
				// 		? updatedAssessmentFormDetails[sectionIndex].multiplePerformanceRoleLinkedFormDetails?.map(
				// 				(ques: any, quesIndex: number) => {
				// 					const quesData = { ...ques };
				// 					if (quesIndex === questionIndex && keyName) {
				// 						if (keyName === 'isCommentExpand') {
				// 							quesData.multipleRatingAssessmentDetail[employeeIndex][keyName] =
				// 								!quesData.multipleRatingAssessmentDetail[employeeIndex]?.isCommentExpand;
				// 						} else {
				// 							if (keyName !== 'starRatingHoverValue' || scaleCommittedFlag) {
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex].isQuestionError = false;
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex].isQuestionErrorMsg = '';
				// 							}
				// 							if (keyName === 'questionCommentBox') {
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex].isQuestionCommentError = false;
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex].isQuestionCommentErrorMsg = '';
				// 							}
				// 							if (keyName === 'ratingValue') {
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex][keyName] = value ? String(value) : '';
				// 								if (
				// 									quesData?.isCommentBoxMandatory &&
				// 									!quesData.multipleRatingAssessmentDetail[employeeIndex]?.questionCommentBox
				// 								) {
				// 									quesData.multipleRatingAssessmentDetail[employeeIndex].isCommentExpand = true;
				// 								}
				// 							} else {
				// 								quesData.multipleRatingAssessmentDetail[employeeIndex][keyName] = value;
				// 							}
				// 						}
				// 					}
				// 					return quesData;
				// 				}
				// 		  )
				// 		: [];

				setAssessmentFormDetails([...updatedAssessmentFormDetails]);
				if (keyName !== 'starRatingHoverValue') {
					setIsFormEdited(true);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	// ===========================================================================
	const handleEmployeeActionClick = (
		e: any,
		type: number,
		section: any,
		sectionIndex: number,
		question: any,
		questionIndex: number,
		employeeDetails: any
	) => {
		try {
			// type 1 (Self Assessment) 2 (Snapshot) 3 (1-on-1)
			if (type === 1) {
				handlePopupClick(e, employeeDetails);
			} else if (type === 2) {
				handleSnapshot(e, employeeDetails);
			} else if (type === 3) {
				handleOneOnOneClick(e, 'MyAssessmentList', employeeDetails?.employeeId);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handlePopupClick = (e: any, details: any) => {
		// e.preventDefault();
		// e.stopPropagation();
		setAssessmentPopup({ open: true, details: details });
	};

	const handleCloseModal = (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalProps?.type === 'ClearForm') {
				if (multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections) {
					setAssessmentFormDetails(
						addQuestionNumber(multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections)
					);
					setIsFormEdited(false);
				}
			} else if (modalProps?.type === 'UnSaveChanges') {
				if (modalProps?.event) {
					setAssessmentFormDetails(
						addQuestionNumber(multipleAssessmentResponse?.multiplePerformanceRoleLinkedFormSections)
					);
					setIsFormEdited(false);
					const { target } = modalProps.event;
					const clonedNativeEvent = document.createEvent('HTMLEvents');
					clonedNativeEvent.initEvent('click', true, false);
					target.dispatchEvent(clonedNativeEvent);
				}
			}
		}
		setModalProps({ open: false, event: null, message: '' });
	};
	const handleCloseDialog = () => {
		setAssessmentPopup({ open: false, details: null });
	};
	return (
		<>
			<div ref={refComp}>
				<Box className='user-assessment-section-area'>
					{assessmentFormDetails && assessmentFormDetails?.length ? (
						assessmentFormDetails?.map((section: any, sectionIndex: number) => {
							const { performanceRoleLinkedFormSectionId = 0, multiplePerformanceRoleLinkedFormDetails } = section;
							return (
								<Box
									className='user-assessment-ques-area'
									key={`section_index_value_${performanceRoleLinkedFormSectionId}`}
								>
									{/* <Box className='user-assessment-ques-head'>
										<Typography variant='h5'>{section?.name || ''}</Typography>
										<Typography>{section?.description || ''}</Typography>
									</Box> */}
									{multiplePerformanceRoleLinkedFormDetails && multiplePerformanceRoleLinkedFormDetails?.length ? (
										multiplePerformanceRoleLinkedFormDetails.map((question: any, questionIndex: number) => {
											const { questionsType, multipleRatingAssessmentDetail } = question;
											return (
												<Box
													// style={
													// 	!isViewMode
													// 		? {
													// 				display:
													// 					question?.isQuestionVisible || (questionIndex === 0 && sectionIndex === 0)
													// 						? ''
													// 						: 'none',
													// 		  }
													// 		: {}
													// }
													key={`section_question_index_value_${performanceRoleLinkedFormSectionId}_${question?.performanceRoleLinkedFormDetailsId}_${question?.performanceRoleLinkedFormScaleId}_`}
													id={`section_question_index_value_${performanceRoleLinkedFormSectionId}_${question?.performanceRoleLinkedFormDetailsId}_${question?.performanceRoleLinkedFormScaleId}_`}
												>
													{questionIndex === 0 ? (
														<Box className='user-assessment-ques-head'>
															<Typography variant='h4'>{section?.name || ''}</Typography>
															<Typography>{section?.description || ''}</Typography>
														</Box>
													) : (
														<></>
													)}
													<Box className='user-assess-ques-list'>
														<Box className={`user-assess-ques-panel light-blue-panel multi-user-assess`}>
															<Box className={'user-assess-ques-type user-assess-ques-rating'}>
																<Box className='user-assess-ques-title'>
																	<Typography variant='h4' className='ques-title font-weight-normal'>
																		<span>{getQuestionNumber(section, question, sectionIndex, questionIndex)}</span>
																		{question?.questionsName || ''}{' '}
																		{question?.isQuestionsMandatory ? <i style={{ color: 'red' }}>*</i> : <></>}
																	</Typography>
																</Box>
																<Box className='user-assess-ques-des'>
																	{multipleRatingAssessmentDetail && multipleRatingAssessmentDetail?.length ? (
																		multipleRatingAssessmentDetail.map((employee: any, employeeIndex: number) => {
																			return (
																				<Box
																					className='user-multiple-row-wrap'
																					key={`section_question_index_value_${performanceRoleLinkedFormSectionId}_${question?.performanceRoleLinkedFormDetailsId}_${question?.performanceRoleLinkedFormScaleId}_${employee?.employeeId}`}
																					id={`section_question_index_value_${performanceRoleLinkedFormSectionId}_${question?.performanceRoleLinkedFormDetailsId}_${question?.performanceRoleLinkedFormScaleId}_${employee?.employeeId}`}
																				>
																					{questionsType === Enums.ONE ? (
																						<>
																							<StarRating
																								t={t}
																								section={section}
																								sectionIndex={sectionIndex}
																								questionIndex={questionIndex}
																								question={question}
																								getQuestionNumber={getQuestionNumber}
																								isViewMode={isViewMode}
																								getSelectedStartValueIndex={getSelectedStartValueIndex}
																								getLabelText={getLabelText}
																								handleChangeStarQuestionValue={(
																									event: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeStarQuestionValue(
																										event,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleChangeStarQuestionHoverValue={(
																									event: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeStarQuestionHoverValue(
																										event,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleCommentsToggle={(
																									e: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleCommentsToggle(
																										e,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleChangeQuestionComment={(
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeQuestionComment(
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								isMultipleUserAssessment={true}
																								employeeDetails={employee}
																								handleEmployeeActionClick={handleEmployeeActionClick}
																								isActionMenuHidden={
																									callingType === 'MyTeamAssessment' ||
																									callingType === 'ThreeSixtyBulkAssessmentFromUser' ||
																									callingType === 'ThreeSixtyBulkAssessment'
																										? true
																										: false
																								}
																							/>
																						</>
																					) : questionsType === Enums.TWO ? (
																						<>
																							<MultiChoiceRating
																								t={t}
																								section={section}
																								sectionIndex={sectionIndex}
																								questionIndex={questionIndex}
																								question={question}
																								getQuestionNumber={getQuestionNumber}
																								isViewMode={isViewMode}
																								handleCommentsToggle={(
																									e: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleCommentsToggle(
																										e,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleChangeQuestionComment={(
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeQuestionComment(
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleChangeMultiChoiceQuestionValue={(
																									event: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeMultiChoiceQuestionValue(
																										event,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								getSelectedMultiChoiceValue={getSelectedMultiChoiceValue}
																								isMultipleUserAssessment={true}
																								employeeDetails={employee}
																								handleEmployeeActionClick={handleEmployeeActionClick}
																								isActionMenuHidden={
																									callingType === 'MyTeamAssessment' ||
																									callingType === 'ThreeSixtyBulkAssessmentFromUser' ||
																									callingType === 'ThreeSixtyBulkAssessment'
																										? true
																										: false
																								}
																							/>
																						</>
																					) : questionsType === Enums.THREE ? (
																						<>
																							<SliderRating
																								t={t}
																								section={section}
																								sectionIndex={sectionIndex}
																								questionIndex={questionIndex}
																								question={question}
																								getQuestionNumber={getQuestionNumber}
																								isViewMode={isViewMode}
																								handleCommentsToggle={(
																									e: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleCommentsToggle(
																										e,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								handleChangeQuestionComment={(
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeQuestionComment(
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								getSelectedScaleValueIndex={getSelectedScaleValueIndex}
																								getDynamicMarks={getDynamicMarks}
																								handleChangeScaleQuestionValue={(
																									event: any,
																									valueIndex: any,
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number,
																									isCommitted: boolean
																								) =>
																									handleChangeScaleQuestionValue(
																										event,
																										valueIndex,
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										isCommitted,
																										employee,
																										employeeIndex
																									)
																								}
																								isMultipleUserAssessment={true}
																								employeeDetails={employee}
																								handleEmployeeActionClick={handleEmployeeActionClick}
																								isActionMenuHidden={
																									callingType === 'MyTeamAssessment' ||
																									callingType === 'ThreeSixtyBulkAssessmentFromUser' ||
																									callingType === 'ThreeSixtyBulkAssessment'
																										? true
																										: false
																								}
																							/>
																						</>
																					) : questionsType === Enums.FOUR ? (
																						<>
																							<ShortAnswerRating
																								t={t}
																								section={section}
																								sectionIndex={sectionIndex}
																								questionIndex={questionIndex}
																								question={question}
																								getQuestionNumber={getQuestionNumber}
																								isViewMode={isViewMode}
																								handleChangeShortQuestionValue={(
																									value: any,
																									question: any,
																									questionIndex: number,
																									section: any,
																									sectionIndex: number
																								) =>
																									handleChangeShortQuestionValue(
																										value,
																										question,
																										questionIndex,
																										section,
																										sectionIndex,
																										employee,
																										employeeIndex
																									)
																								}
																								isMultipleUserAssessment={true}
																								employeeDetails={employee}
																								handleEmployeeActionClick={handleEmployeeActionClick}
																								isActionMenuHidden={
																									callingType === 'MyTeamAssessment' ||
																									callingType === 'ThreeSixtyBulkAssessmentFromUser' ||
																									callingType === 'ThreeSixtyBulkAssessment'
																										? true
																										: false
																								}
																							/>
																						</>
																					) : (
																						<></>
																					)}
																				</Box>
																			);
																		})
																	) : (
																		<></>
																	)}
																</Box>
															</Box>
														</Box>
													</Box>
												</Box>
											);
										})
									) : (
										<></>
									)}
								</Box>
							);
						})
					) : (
						<></>
					)}
					{assessmentFormDetails && assessmentFormDetails?.length && !isViewMode ? (
						<>
							<Box className='user-assessment-notes-txt'>
								<Typography variant='subtitle2'>
									{t('note')} {t('prsResponseModifyNote')}
								</Typography>
							</Box>
							<Box className='user-assessment-action multiple-assessment-action'>
								<OKRButton
									handleClick={handleClearAssessmentForm}
									className={'btn-link'}
									id={'btn-delete'}
									text={t('clearForm')}
									disabled={loader || !isFormEdited}
								/>
								<Box className={'action-right'}>
									<OKRButton
										className={'btn-link'}
										id={'btn-save-draft'}
										text={t('saveAsDraft')}
										disabled={loader}
										handleClick={handleSaveAsDraftAssessmentForm}
									/>
									{/* {!isInitialRender ? ( */}
									<OKRButton
										className={'btn-primary'}
										id={'btn-submit'}
										text={t('submit')}
										disabled={loader}
										handleClick={handleSubmitAssessmentForm}
									/>
									{/* ) : (
										<></>
									)}
									<Box className='sliding-btn'>
										<OKRButton
											className={'btn-link prev-link'}
											// id={'btn-delete'}
											text={t('Previous')}
											icon={<NextIcon />}
											handleClick={handlePreviousQuestionClick}
										/>
										<OKRButton
											className={'btn-link next-link'}
											// id={'btn-delete'}
											text={t('Next')}
											icon={<NextIcon />}
											handleClick={handleNextQuestionClick}
										/>
									</Box> */}
								</Box>
							</Box>
						</>
					) : (
						<></>
					)}
				</Box>
			</div>
			{assessmentPopup && assessmentPopup?.open ? (
				<AssessmentPopup
					setAssessmentPopup={setAssessmentPopup}
					assessmentPopup={assessmentPopup}
					handleCloseDialog={handleCloseDialog}
					performanceCycleId={performanceCycleId}
					performanceCycle={performanceCycle}
					getSelfAssessmentDetails={getSelfAssessmentDetails}
					loader={loader}
					setLoader={setLoader}
					selectedUserDetails={assessmentPopup?.details || null}
				/>
			) : (
				<></>
			)}

			{modalProps.open && (
				<AlertDialog
					message={modalProps?.message || ''}
					handleCloseModal={handleCloseModal}
					modalOpen={modalProps.open}
				/>
			)}
		</>
	);
};
